import { render, staticRenderFns } from "./CatalogPage.vue?vue&type=template&id=37296dac&scoped=true&"
import script from "./CatalogPage.vue?vue&type=script&lang=js&"
export * from "./CatalogPage.vue?vue&type=script&lang=js&"
import style0 from "./CatalogPage.vue?vue&type=style&index=0&id=37296dac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37296dac",
  null
  
)

export default component.exports